import { Component } from '@angular/core';

interface CarouselItem {
	src: string;
	alt: string;
}

@Component({
	selector: 'seira-public-footer',
	templateUrl: './public-footer.component.html',
	styleUrls: ['./public-footer.component.scss'],
})
export class PublicFooterComponent {
	carouselItems: CarouselItem[] = [
		{
			src: 'assets/images/logos/aesa.png',
			alt: 'aesa',
		},
		{
			src: 'assets/images/logos/governo_pb.png',
			alt: 'governo',
		},
		{
			src: 'assets/images/logos/cooperar.png',
			alt: 'cooperar',
		},

		{
			src: 'assets/images/logos/banco_mundial.png',
			alt: 'banco mundial',
		},
	];

	sobreInfo = [
		{
			title: 'Sobre o SEIRA',
			links: [
				{ label: 'Visão geral', path: '#' },
				{ label: 'Termos de serviço', path: '#' },
				{ label: 'Política de privacidade', path: '#' },
				{ label: 'Política de cookies', path: '#' },
			],
		},
		{
			title: 'Sobre a AESA',
			links: [
				{
					label: 'Informações básicas',
					path: 'https://www.aesa.pb.gov.br/aesa-website/institucional/informacoes-basicas-2/',
				},
				{
					label: 'Quem somos',
					path: '/quem-somos',
					isRouterLink: true,
				},
				{
					label: 'Conselho Estadual',
					path: 'https://www.aesa.pb.gov.br/aesa-website/institucional/plano-estadual/',
				},
				{
					label: 'Fiscalização',
					path: 'https://www.aesa.pb.gov.br/aesa-website/institucional/fiscalizacao/',
				},
			],
		},
	];
}
